import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-text-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-2" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker p-mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_PosCustomersTable = _resolveComponent("PosCustomersTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      disabled: !!_ctx.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = true)),
      class: "p-button-secondary",
      label: "@"
    }, null, 8, ["disabled"]),
    _createVNode(_component_AutoComplete, {
      dropdown: false,
      multiple: false,
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      suggestions: _ctx.autoFilteredValues,
      onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter($event))),
      field: "name",
      placeholder: _ctx.$t('customer.customerName'),
      "force-selection": true,
      disabled: !!_ctx.disabled
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(slotProps.item.name), 1)
        ]),
        (slotProps.item.address)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(slotProps.item.address), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value", "suggestions", "placeholder", "disabled"]),
    _createVNode(_component_Dialog, {
      position: "topright",
      header: _ctx.$t('customer.findClient'),
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      modal: true,
      breakpoints: { '960px': '96vw' },
      style: { width: '800px' }
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(_component_PosCustomersTable, {
          items: _ctx.customers.items,
          "model-value": _ctx.modelValue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => {
        _ctx.$emit('update:modelValue', $event);
        _ctx.visible = false;
      }),
          "selection-mode": "single"
        }, null, 8, ["items", "model-value"])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}